import { useEffect, useState } from "react";
import { Modal, Col, Button } from "reactstrap";

const ModalBlockRulesDetails = ({
  scoreBlockResults,
  segmentId,
  promptsData,
  evaluableEventsData,
  librariesData,
}) => {
  const [toggle, setToggle] = useState(false);
  const [formattedRules, setFormattedRules] = useState([]);
  useEffect(() => {
    if (toggle && scoreBlockResults?.length) {
      formatBlockRules(scoreBlockResults).then(setFormattedRules);
    }
  }, [toggle, scoreBlockResults]);

  const formatBlockRules = async (blocks) => {
    const formatted = [];

    for (const block of blocks) {
      const blockData = {
        blockTitle: block.blockTitle || block.title || "Sem título",
        blockColor: block.blockColor || "#007bff",
        blockScore: block.blockScore || block.score,
        priority: block.priority,
        rules: [],
      };

      if (block.blockConfig && Array.isArray(block.blockConfig)) {
        for (const config of block.blockConfig) {
          if (config.promptId) {
            const promptData = promptsData?.find(
              (p) => p.promptId === config.promptId,
            );
            const promptTitle =
              promptData?.title || `Prompt ${config.promptId}`;

            if (config.config && Array.isArray(config.config)) {
              for (const ruleConfig of config.config) {
                blockData.rules.push({
                  type: "prompt",
                  title: promptTitle,
                  rule: formattingRules(ruleConfig.rule),
                  score: ruleConfig.score,
                  priority: ruleConfig.priority,
                });
              }
            }
          }

          if (config.evaluableEventId) {
            const eventData = evaluableEventsData?.find(
              (e) => e.id === config.evaluableEventId,
            );
            const eventTitle =
              eventData?.title || `Evento ${config.evaluableEventId}`;

            if (config.config && Array.isArray(config.config)) {
              for (const ruleConfig of config.config) {
                blockData.rules.push({
                  type: "evaluableEvent",
                  title: eventTitle,
                  rule: formattingRules(ruleConfig.rule),
                  score: ruleConfig.score,
                  priority: ruleConfig.priority,
                });
              }
            }
          }
        }
      }

      formatted.push(blockData);
    }

    return formatted;
  };

  function formattingRules(rules) {
    let formattedRule = "";

    rules.forEach((rule, index) => {
      if (Array.isArray(rule)) {
        rule.forEach((r, i) => {
          formattedRule += ` <b>${r.key}</b> ${translateCondition(r.condition)} ${r.value} `;
          if (rule[i + 1]) {
            formattedRule += " E ";
          }
        });
      } else {
        formattedRule += ` <b>${rule.key}</b> ${translateCondition(rule.condition)} ${rule.value} `;
      }
      if (rules[index + 1]) {
        formattedRule += " OU ";
      }
    });

    return formattedRule;
  }

  function translateCondition(condition) {
    const conditionMap = {
      GREATER_THAN_OR_EQUAL: "maior ou igual a",
      LESS_THAN_OR_EQUAL: "menor ou igual a",
      GREATER_THAN: "maior que",
      LESS_THAN: "menor que",
      EQUAL_TO: "igual a",
      NOT_EQUAL_TO: "diferente de",
      NULL: "nulo ou vazio",
      CONTAINS: "contém",
      NOT_CONTAINS: "não contém",
    };
    return conditionMap[condition] || condition;
  }

  const getTypeLabel = (type) => {
    const typeMap = {
      prompt: "Prompt",
      evaluableEvent: "Evento Avaliável",
      library: "Biblioteca",
    };
    return typeMap[type] || type;
  };

  return (
    <Col lg="12" style={{ padding: 0 }}>
      <Button
        className="Button"
        size="sm"
        color="info"
        onClick={() => setToggle(true)}
      >
        {scoreBlockResults?.length === 0 || !scoreBlockResults
          ? "Sem blocos"
          : scoreBlockResults?.length === 1
            ? "1 bloco"
            : scoreBlockResults?.length + " blocos"}
      </Button>
      <Modal
        className="modal-dialog modal-xl"
        style={{ marginTop: "50px" }}
        isOpen={toggle}
        toggle={() => setToggle((v) => !v)}
      >
        <div className="modal-header">
          <h4 className="modal-title">Detalhes dos Blocos de Regras</h4>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setToggle((v) => !v)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div
          className="modal-body"
          style={{ maxHeight: "70vh", overflowY: "auto" }}
        >
          {formattedRules?.length ? (
            formattedRules.map((block, blockIndex) => (
              <div key={blockIndex} className="mb-4">
                <div
                  className="card"
                  style={{
                    borderLeft: `6px solid ${block.blockColor}`,
                    marginBottom: "20px",
                  }}
                >
                  <div
                    className="card-header"
                    style={{ backgroundColor: "#f8f9fa" }}
                  >
                    <h5 className="mb-0">
                      <span
                        style={{
                          color: block.blockColor,
                          fontWeight: "bold",
                        }}
                      >
                        {block.blockTitle}
                      </span>
                      <span className="ml-2">
                        <small className="text-muted">
                          Pontuação: {block.blockScore} | Classificação:{" "}
                          {block.priority ? "Crítico" : "Processual"}
                        </small>
                      </span>
                    </h5>
                  </div>
                  <div className="card-body">
                    {block.rules.length > 0 ? (
                      <table className="table table-sm table-striped">
                        <thead>
                          <tr>
                            <th style={{ width: "15%" }}>Tipo</th>
                            <th style={{ width: "35%" }}>Título</th>
                            <th style={{ width: "50%" }}>Regra</th>
                          </tr>
                        </thead>
                        <tbody>
                          {block.rules.map((rule, ruleIndex) => (
                            <tr key={ruleIndex}>
                              <td>
                                <span className="badge badge-secondary">
                                  {getTypeLabel(rule.type)}
                                </span>
                              </td>
                              <td>
                                <strong>{rule.title}</strong>
                              </td>
                              <td>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: rule.rule,
                                  }}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <p className="text-muted">
                        Este bloco não possui regras configuradas.
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-muted">
              Não há blocos de regras configurados.
            </p>
          )}
        </div>
        <div className="modal-footer">
          <Button
            type="button"
            color="secondary"
            onClick={() => setToggle((v) => !v)}
          >
            Fechar
          </Button>
        </div>
      </Modal>
    </Col>
  );
};

export default ModalBlockRulesDetails;
